import './switch.css';

export function Switch(props) {
    const isActive = props.value ? "active" : "";
    const isDisabled = props.disabled ? "disabled" : "";
    const isReverse = props.reverse ? "reverse" : "";
    const className = props.class ? props.class : "";

    const clicked = () => {
        if (props.disabled) {
            return;
        }

        const value = props.value ? false : true;

        if (props.valueChanged) {
            props.valueChanged(value);
        }
    };

    return (
        <div className={`switch-container ${isActive} ${isDisabled} ${isReverse} ${className}`}>
            <button className="switch" onClick={() => clicked()}></button>
            <div className="switch-content">
                {props.children}
            </div>
        </div>
    );
}